import { render, staticRenderFns } from "./ApplyCreate.vue?vue&type=template&id=b2d17ad8&scoped=true"
import script from "./ApplyCreate.vue?vue&type=script&lang=js"
export * from "./ApplyCreate.vue?vue&type=script&lang=js"
import style0 from "./ApplyCreate.vue?vue&type=style&index=0&id=b2d17ad8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2d17ad8",
  null
  
)

export default component.exports